// extracted by mini-css-extract-plugin
module.exports = {"orderWrapper":"dlc-cart-orders_orderWrapper__SpxxM"};